module.exports = __webpack_public_path__ + "img/k-3-hover.237905cf.png";